import { render } from "./buy.vue?vue&type=template&id=e17b755e&scoped=true"
import script from "./buy.vue?vue&type=script&lang=js"
export * from "./buy.vue?vue&type=script&lang=js"

import "./buy.vue?vue&type=style&index=0&id=e17b755e&lang=less&scoped=true"
import "./buy.vue?vue&type=style&index=1&id=e17b755e&lang=less"
import "./buy.vue?vue&type=style&index=2&id=e17b755e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e17b755e"]])

export default __exports__